const getAriaDescribedBy = (isInvalid) => {
    const result = ['help-text', isInvalid && 'validation-message'].filter(Boolean).join(' ');
    return result;
};
const getAriaInvalid = (isInvalid) => {
    const result = isInvalid ? 'true' : 'false';
    return result;
};
const getAriaDisabled = (isDisabled) => {
    const result = isDisabled ? 'true' : undefined;
    return result;
};
const getAriaRequired = (isRequired) => {
    const result = isRequired ? 'true' : undefined;
    return result;
};
const getAriaExpanded = (isExpanded) => {
    const result = isExpanded ? 'true' : 'false';
    return result;
};

export { getAriaDescribedBy as a, getAriaInvalid as b, getAriaDisabled as c, getAriaExpanded as d, getAriaRequired as g };
